import React from 'react'
import './PlanEntriesList.scss'
import StopwatchSvg from '../../../assets/codicons/stopwatch'
import CalendarSvg from '../../../assets/codicons/logging/log-calendar.svg'
import PlanEntriesListContent from './PlanEntriesListContent'
import PropTypes from 'prop-types'

// Note that the planEntries array takes objects of this form
// { obj: PlanEntryObject, id: unique identifier for each row, and createdAt field representing when entry was added to the list }
// This was so that we could allow for duplicate plan entries and also so that the createdAt field won't be the createdAt field of the PlanEntry instance
/*
  Sample object from PlaylistEntries
  {
    obj: PlanEntry Object
    id: PlaylistEntry.id
    createdAt: PlaylistEntry.createdAt
  }
*/
class PlanEntriesList extends React.Component {
  constructor (props) {
    super(props)

    this.handleSort = this.handleSort.bind(this)
  }

  handleSort (order, parameter) {
    this.setState({ orderBy: parameter })
    this.props.onSort(order, parameter)
  }

  generateHeaders () {
    const headerObj = (value, label) => {
      label = label || value
      return {
        label,
        value
      }
    }

    let headers = [
      headerObj('title'),
      headerObj('coach', 'Instructor'),
      headerObj('plan', 'Series'),
      headerObj('duration', <StopwatchSvg />)
    ]

    if (this.props.includeDates) {
      headers = headers.concat([headerObj('date', <CalendarSvg />)])
    }

    return headers
  }

  render () {
    const headers = this.generateHeaders()

    return (
      <PlanEntriesListContent
        {...this.props}
        headers={headers}
        handleSort={this.handleSort}
        hasMore={this.props.entries.length < this.props.totalPlanEntries}
      />
    )
  }
}

PlanEntriesList.defaultProps = {
  autopaginate: true
}

PlanEntriesList.propTypes = {
  autopaginate: PropTypes.bool,
  entries: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  favoritable: PropTypes.bool,
  featurable: PropTypes.bool,
  headers: PropTypes.object,
  onReorder: PropTypes.func,
  orderBy: PropTypes.string,
  hasMore: PropTypes.bool,
  onFetchMoreEntries: PropTypes.func,
  sortable: PropTypes.bool,
  onDeleted: PropTypes.func,
  removable: PropTypes.bool,
  locked: PropTypes.bool,
  includeDates: PropTypes.bool,
  initialLoad: PropTypes.bool,
  totalPlanEntries: PropTypes.number.isRequired,
  onSort: PropTypes.func,
  entryLinkSuffix: PropTypes.string
}

export default PlanEntriesList
